import styled from "styled-components";
import { Button, ButtonLink, typography } from "@streeteasy/design-system";
import { ACCENT_PRIMARY_LIGHTEST } from "@streeteasy/design-system/colors";

const { P } = typography;

export const Container = styled.div`
  align-items: center;
  background-color: ${ACCENT_PRIMARY_LIGHTEST};
  display: flex;
  flex-direction: column;
  padding: 24px;
`;

export const SellerLandingIcon = styled.img`
  border-radius: 50%;
  height: 72px;
  width: 72px;
`;

export const Content = styled(P)`
  margin-top: 16px;
  text-align: center;
`;

export const DashboardButton = styled(ButtonLink)`
  margin-top: 16px;
  width: 222px;
`;

export const CloseButton = styled(Button).attrs({
  theme: "SECONDARY"
})`
  margin-top: 16px;
  width: 222px;
`;
